// autoRegister.js
/**
 * 全局组件自动注册 根目录下所有组件
 *
 * 组件必须设置 name 并保证其唯一，自动注册会将组件的 name 设为组件名，可参考 SvgIcon 组件写法
 */
import Vue from 'vue';
const componentsContext = require.context('./', true, /.(vue)$/)

componentsContext.keys().forEach(file_name => {
  try {
    // 获取文件中的 default 模块 (若是.vue文件，则componentConfig就是一个vue组件)
    const componentConfig = componentsContext(file_name).default
    if ((/.vue$/).test(file_name)) {//vue文件
      Vue.component(componentConfig.name, componentConfig)
    } else { //js文件
      Vue.use(componentConfig)
    }
  }
  catch (error) {
    console.log(error);
    console.log('=========  注册组件失败 =========');
  }
});



